import { SearchError, ValidationMethod } from "../../types/analytics";
import { ProductType } from "../../types/common";
import { DateRangeData, LocationData } from "../../types/form-data";
import { GuestsData } from "vacv-components";

// dataLayer initialization in case we are not in Hybris environment
window.dataLayer = window.dataLayer || [];

const suggestionTypeMap = {
  CITY: "City",
  REGION: "Region",
  COUNTRY: "Country",
  AIRPORTGROUP: "Airport",
  HOTEL: "Hotel",
  LANDMARK: "Landmark",
};

export const dataLayerSearchWidgetSuggestion = (
  suggestionValue: LocationData,
  departureCode: LocationData["code"]
) => {
  window.dataLayer.push({
    event: "searchWidgetSuggestion",
    swSuggestion: suggestionValue.name,
    swSuggestionType: suggestionTypeMap[suggestionValue.type],
    swDepartureAirport: departureCode,
  });
};

// https://aircanadavacations.atlassian.net/wiki/spaces/AW/pages/3097460751/Tracking+of+Search+Widget+Search+Button+Clicks+searchWidgetSearch
export const dataLayerSearchWidgetSearch = (type: ProductType) => {
  window.dataLayer.push({
    event: "searchWidgetSearch",
    swProductTypeTab: type,
    swLocation: window.location.href,
  });
};

export const dataLayerSearchWidgetError = (errorMessage: SearchError) => {
  window.dataLayer.push({
    event: "searchWidgetError",
    swErrorMessage: errorMessage,
  });
};

export const dataLayerSearchWidgetDateValidationMethod = (
  method: ValidationMethod
) => {
  window.dataLayer.push({
    event: "searchWidgetDateValidationMethod",
    swDateValidationMethod: method,
  });
};

export const dataLayerSearchWidgetUseDuration = (duration: string) => {
  window.dataLayer.push({
    event: "searchWidgetUseDuration",
    swUseDuration: duration,
  });
};

export const dataLayerSearchWidgetTabClick = (productType: ProductType) => {
  window.dataLayer.push({
    event: "searchWidgetTab",
    swTab: productType,
  });
};

export const dataLayerSearchWidgetExpand = (expanded: boolean) => {
  window.dataLayer.push({
    event: "pageElements",
    pageElementName: expanded
      ? "Search Widget Expand"
      : "Search Widget Collapse",
    mpePageURL: document.location.href,
  });
};

const getFilledPropertiesString = (
  departureLocation?: LocationData,
  arrivalLocation?: LocationData,
  dateRange?: DateRangeData,
  guests?: GuestsData,
  cabinClass?: string
): string => {
  const filledProperties = [];
  if (departureLocation) {
    filledProperties.push("From");
  }
  if (arrivalLocation) {
    filledProperties.push("To");
  }
  if (dateRange?.departureDate) {
    filledProperties.push("Departure");
  }
  if (dateRange?.returnDate) {
    filledProperties.push("Return");
  }
  if (guests) {
    filledProperties.push("Guests");
  }
  if (cabinClass) {
    filledProperties.push("CabinClass");
  }

  return filledProperties.join(" > ");
};

export const dataLayerSearchWidgetAbandonment = (
  departureLocation?: LocationData,
  arrivalLocation?: LocationData,
  dateRange?: DateRangeData,
  guests?: GuestsData,
  cabinClass?: string,
  isAbandonnedByClick?: boolean
) => {
  const filledProperties = getFilledPropertiesString(
    departureLocation,
    arrivalLocation,
    dateRange,
    guests,
    cabinClass
  );
  window.dataLayer.push({
    event: "searchWidgetAbandonment",
    swCompletedFields: filledProperties,
    swAbandonmentScenario: isAbandonnedByClick
      ? "Click Outside of Search Widget"
      : "3+ Minute Delay",
  });
};
